module.exports = __webpack_public_path__ + "img/vector-graphic@3x.587b2fda.png";